import {
  CalendarTodayFilterIcon,
  EmptyFavoritesListIcon,
  EmptyRecommendedProsIcon,
} from '~/images/emptyScreenIcons';

export const EmptyFavoriteProfessionalCopy = {
  Icon: EmptyFavoritesListIcon,
  title: 'No favorite professionals at this time!',
  description:
    'Your office have no added any professionals to your favorites list. There are three ways you can add a professional to your favorites:',
  steps: [
    {
      title: 'End-of-day review:',
      description: 'Click “Add to Favorites” when prompted to leave a review for a professional.',
    },
    {
      title: 'Completed Shifts screen:',
      description: 'Go to Schedule > Completed Shifts, and view the Shift Details screen.',
    },
    {
      title: 'Professionals Hub:',
      description: 'You can add the professionals you have recently worked with to your favorites.',
    },
  ],
};

export const EmptyWorkedWithProfessionalCopy = {
  Icon: CalendarTodayFilterIcon,
  title: 'No professionals on this list at this time!',
  description:
    "It looks like you haven't completed any shifts yet! Once a professional completes a shift, they will appear on this screen where you will be able send direct invites to upcoming shifts.",
};

export const EmptyNewToYouProfessionalCopy = {
  Icon: EmptyRecommendedProsIcon,
  title: 'No new professionals at this time!',
  description:
    'We are searching for professionals who meet the “New to You” criteria in your area. Come back soon to see who we find!',
};
